(function () {
  if (window.__heaRecommendedCarouselBootstrapped) return;
  window.__heaRecommendedCarouselBootstrapped = true;

  function initCarousel(root) {
    if (!root || root.__heaRecommendedCarouselInit) return;

    var track = root.querySelector('[data-rec-carousel]');
    if (!track) return;

    root.__heaRecommendedCarouselInit = true;

    var prevBtn = root.querySelector('[data-rec-prev]');
    var nextBtn = root.querySelector('[data-rec-next]');
    var progressThumb = root.querySelector('.rec-slider__progress-thumb');
    var updateFrame;

    function getScrollAmount() {
      var slide = track.querySelector('.rec-slider__slide');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return slide ? slide.offsetWidth + gap : 300;
    }

    function updateCarouselState() {
      var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      var visibleRatio = track.scrollWidth ? Math.min(track.clientWidth / track.scrollWidth, 1) : 1;
      var position = maxScroll ? Math.min(Math.max(track.scrollLeft / maxScroll, 0), 1) : 0;

      if (progressThumb) {
        var width = visibleRatio * 100;
        progressThumb.style.width = width + '%';
        progressThumb.style.left = position * (100 - width) + '%';
      }
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function requestStateUpdate() {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(updateCarouselState);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', requestStateUpdate, { passive: true });
    window.addEventListener('resize', requestStateUpdate);
    window.addEventListener('load', requestStateUpdate, { once: true });
    root.__heaRecommendedCarouselUpdate = requestStateUpdate;
    requestStateUpdate();
  }

  function initAll(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    target.querySelectorAll('[data-rec-slider]').forEach(initCarousel);
    if (target.matches && target.matches('[data-rec-slider]')) initCarousel(target);
  }

  window.HEAInitRecommendedCarousel = initCarousel;

  document.addEventListener('hea:recommended-carousel:refresh', function (event) {
    var root = event.detail && event.detail.root;
    initCarousel(root);
    if (root && root.__heaRecommendedCarouselUpdate) root.__heaRecommendedCarouselUpdate();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
